import { BaseInput } from '@/components/Form/BaseInput';
import { ArrowRightIcon, CalendarIcon } from '@heroicons/react/16/solid';
import { enUS } from 'date-fns/locale/en-US';
import { ja } from 'date-fns/locale/ja';
import ReactDatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.min.css';

registerLocale('ja', ja);
registerLocale('en', enUS);

// react-datepickerの型定義でunion型を利用しており、generics などを利用して事前に型を絞り込むことができないため、
// 明示的に型を定義する必要がある。
type SingleDatePickerProps = {
  selected?: Date | null;
  onChange?: (
    date: Date | null,
    event?: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>
  ) => void;
  locale?: string;
  minDate?: Date | null;
};

const ReactDatePickerBase = ({
  selected,
  onChange,
  locale,
  minDate,
}: SingleDatePickerProps) => (
  <ReactDatePicker
    selected={selected}
    onChange={onChange}
    locale={locale}
    minDate={minDate || undefined}
    className="rounded-none rounded-tr-xl border-2 border-rw-light-gray text-black shadow-none"
    customInput={
      <BaseInput
        icon={<CalendarIcon className="size-4 text-rw-gray" />}
        className="!px-2 shadow-none"
      />
    }
    placeholderText="y/m/d"
    dateFormat="yyyy/MM/dd"
    todayButton="Today"
    popperPlacement="bottom-start"
    popperClassName="z-[9999]"
  />
);

type DateRangePickerProps = {
  label?: string;
  locale?: string;
  selectedStart?: Date | null | undefined;
  selectedEnd?: Date | null | undefined;
  onStartChange?: (
    date: Date | null,
    event?: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>
  ) => void;
  onEndChange?: (
    date: Date | null,
    event?: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>
  ) => void;
};

export const DateRangePicker = ({
  label,
  locale,
  selectedStart,
  selectedEnd,
  onStartChange,
  onEndChange,
}: DateRangePickerProps) => {
  return (
    <div>
      <div className="block text-xs font-medium">{label}</div>
      <div className="mt-1 flex items-center">
        <ReactDatePickerBase
          selected={selectedStart ?? null}
          onChange={onStartChange}
          locale={locale}
        />
        <ArrowRightIcon className="mx-1 size-5" />
        <ReactDatePickerBase
          selected={selectedEnd ?? null}
          minDate={selectedStart ?? null}
          onChange={onEndChange}
          locale={locale}
        />
      </div>
    </div>
  );
};
